// extracted by mini-css-extract-plugin
module.exports = {"form":"MailChimpForm_form__3q3vr","input":"MailChimpForm_input__2g0S0"};